
export const unDisableButon = (id: string) => {
    // @ts-ignore
    const element = window.$(`#${id}`)
    // //console.log(element)
    element.prop("disabled", false)
}